/**
 * Lists the supervisions a customer invoice can be linked to: those of the
 * customer held by the form, as owner or pensioner, along with the
 * supervision the invoice is already linked to. Every supervision is listed
 * until the customer is known.
 *
 * @param {Object} options - Options for listing the supervisions.
 * @param {Array} options.customers - Owners and pensioners, populated with their user.
 * @param {Array} options.supervisions - List of supervisions.
 * @param {string} options.customerUserId - User ID held by the customer field.
 * @param {string} options.supervisionId - ID held by the supervision field.
 * @returns {Array} The supervisions to offer in the supervision field.
 */
export const getCustomerSupervisions = ({
  customers,
  supervisions,
  customerUserId,
  supervisionId
}) => {
  const customer = (customers || []).find(
    ({ user }) => user?._id === customerUserId
  );

  if (!customer) return supervisions || [];

  return (supervisions || []).filter(
    (s) =>
      s._id === supervisionId ||
      s.owner === customer._id ||
      s.pensioners?.includes(customer._id)
  );
};
